export const COLORS = {
  '<1yr': 'rgb(218, 30, 40)',
  '2yrs': 'rgb(255, 131, 43)',
  '3yrs': 'rgb(253, 220, 105)',
  '4yrs': 'rgb(36, 161, 72)',
  '5yrs': 'rgb(15, 98, 254)',
  '>5yrs': 'rgb(128, 0, 128)',
};
